import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: 'https://fitswitch.co.il/api',
  // baseURL: 'http://localhost:8000/api',
  timeout: 10000,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling and token refresh
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't tried to refresh yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // If already refreshing, queue this request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem('admin_refresh');
      
      if (!refreshToken) {
        // No refresh token, clear storage and reject
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_refresh');
        isRefreshing = false;
        processQueue(error, null);
        // Don't redirect here, let the app handle it
        return Promise.reject(error);
      }

      try {
        // Try to refresh the token - use the correct endpoint
        const response = await axios.post(`${api.defaults.baseURL}/admin/auth/token/refresh/`, {
          refresh: refreshToken
        });

        const newAccessToken = response.data.access;
        localStorage.setItem('admin_token', newAccessToken);
        
        // Update the authorization header
        api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        
        processQueue(null, newAccessToken);
        isRefreshing = false;
        
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed, clear tokens
        processQueue(refreshError, null);
        isRefreshing = false;
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_refresh');
        // Don't redirect here, let the app handle it
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
